import { render, staticRenderFns } from "./AppContrato.vue?vue&type=template&id=5b0313b4&"
import script from "./AppContrato.vue?vue&type=script&lang=js&"
export * from "./AppContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports